(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTabs() {
      // Solo ejecutar en desktop (mobile usa accordions nativos)
      if (window.innerWidth <= 749) {
        return;
      }

      document.querySelectorAll('.product-info-tabs').forEach(function(tabsContainer) {
        const tabs = tabsContainer.querySelectorAll('.js-product-info-tab');
        const panels = tabsContainer.querySelectorAll('.js-product-info-tab-panel');
        const accordionItems = tabsContainer.querySelectorAll('.product-info-tabs__accordion-item--desktop');

        tabs.forEach(function(tab) {
          // Evitar agregar listeners duplicados
          if (tab.hasAttribute('data-tab-listener')) {
            return;
          }
          tab.setAttribute('data-tab-listener', 'true');
          
          tab.addEventListener('click', function() {
            const targetId = this.getAttribute('data-tab-target');

            if (targetId && targetId.startsWith('#product-')) {
              const targetPanel = tabsContainer.querySelector(targetId);
              if (targetPanel) {
                tabs.forEach(function(t) {
                  t.classList.remove('is-active');
                });
                panels.forEach(function(p) {
                  p.classList.remove('is-active');
                });

                this.classList.add('is-active');
                targetPanel.classList.add('is-active');
                
                // En desktop: mantener accordions abiertos pero controlar visibilidad con CSS
                accordionItems.forEach(function(item) {
                  const itemPanel = item.querySelector('.js-product-info-tab-panel');
                  if (itemPanel === targetPanel) {
                    item.open = true;
                  } else {
                    item.open = false;
                  }
                });
              
                // Si es el panel de overview, disparar evento para que el parser se ejecute
                if (targetId.includes('product-overview-panel')) {
                  setTimeout(function() {
                    window.dispatchEvent(new CustomEvent('overview-panel-shown'));
                  }, 100);
                }
              }
            } else if (targetId) {
              const targetElement = document.querySelector(targetId);
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }
          });
        });
      });
    }

    // Funcionalidad de búsqueda y filtrado en specs
    function initSpecsSearch() {
      document.querySelectorAll('[data-specs-panel]').forEach(function(specsPanel) {
        // Evitar re-inicialización duplicada
        if (specsPanel.hasAttribute('data-specs-initialized')) {
          return;
        }
        specsPanel.setAttribute('data-specs-initialized', 'true');
        
        const searchInput = specsPanel.querySelector('.product-specs__search-input');
        const chips = specsPanel.querySelectorAll('.product-specs__chip');
        const groups = specsPanel.querySelectorAll('.product-specs__group');

      // Filtrado por chips
      chips.forEach(function(chip) {
        // Evitar listeners duplicados
        if (chip.hasAttribute('data-chip-listener')) {
          return;
        }
        chip.setAttribute('data-chip-listener', 'true');
        
        chip.addEventListener('click', function() {
          const groupId = this.getAttribute('data-group-id');
          const namespace = this.getAttribute('data-namespace');

          // Actualizar estado activo de chips
          chips.forEach(function(c) {
            c.classList.remove('product-specs__chip--active');
            c.setAttribute('aria-selected', 'false');
          });
          this.classList.add('product-specs__chip--active');
          this.setAttribute('aria-selected', 'true');

          // Mostrar/ocultar grupos
          groups.forEach(function(group) {
            const groupNamespace = group.getAttribute('data-namespace');
            if (namespace === 'all') {
              group.style.display = '';
              // Mostrar todos los items del grupo
              const items = group.querySelectorAll('.product-specs__item');
              items.forEach(function(item) {
                item.style.display = '';
              });
            } else if (groupNamespace === namespace) {
              group.style.display = '';
              // Mostrar todos los items del grupo
              const items = group.querySelectorAll('.product-specs__item');
              items.forEach(function(item) {
                item.style.display = '';
              });
            } else {
              group.style.display = 'none';
            }
          });

          // Limpiar búsqueda
          if (searchInput) {
            searchInput.value = '';
          }
        });
      });

        // Búsqueda
        if (searchInput) {
          searchInput.addEventListener('input', function() {
            const searchTerm = this.value.toLowerCase().trim();
            
            if (searchTerm === '') {
              // Si no hay búsqueda, mostrar todos los grupos del chip activo
              const activeChip = specsPanel.querySelector('.product-specs__chip--active');
              if (activeChip) {
                activeChip.click();
              } else {
                groups.forEach(function(group) {
                  group.style.display = '';
                });
              }
              return;
            }

            // Filtrar items dentro de cada grupo
            groups.forEach(function(group) {
              const items = group.querySelectorAll('.product-specs__item');
              let hasVisibleItems = false;

              items.forEach(function(item) {
                const label = item.querySelector('.product-specs__item-label')?.textContent?.toLowerCase() || '';
                const value = item.querySelector('.product-specs__item-value')?.textContent?.toLowerCase() || '';
                
                if (label.includes(searchTerm) || value.includes(searchTerm)) {
                  item.style.display = '';
                  hasVisibleItems = true;
                } else {
                  item.style.display = 'none';
                }
              });

              // Mostrar/ocultar grupo según si tiene items visibles
              group.style.display = hasVisibleItems ? '' : 'none';
            });
          });
        }
      });
    }
    
    // Inicializar búsqueda de specs
    initSpecsSearch();

    // Inicializar tabs al cargar
    initTabs();

    // Re-inicializar tabs después de morphing (cambio de variante)
    // Esto es crítico porque Shopify reemplaza el DOM y se pierden los event listeners
    function reinitTabsAfterMorphing() {
      // Guardar la tab activa ANTES del morphing para restaurarla después
      const activeTabBeforeMorph = document.querySelector('.product-info-tabs .js-product-info-tab.is-active');
      const activeTabTarget = activeTabBeforeMorph ? activeTabBeforeMorph.getAttribute('data-tab-target') : null;
      const isOverviewActiveBeforeMorph = activeTabTarget && activeTabTarget.includes('product-overview-panel');
      
      // Remover atributos de listeners anteriores para permitir re-inicialización
      document.querySelectorAll('.product-info-tabs .js-product-info-tab[data-tab-listener]').forEach(function(tab) {
        tab.removeAttribute('data-tab-listener');
      });
      document.querySelectorAll('.product-specs__chip[data-chip-listener]').forEach(function(chip) {
        chip.removeAttribute('data-chip-listener');
      });
      document.querySelectorAll('[data-specs-panel][data-specs-initialized]').forEach(function(panel) {
        panel.removeAttribute('data-specs-initialized');
      });
      document.querySelectorAll('[data-accessories-container][data-accessories-initialized]').forEach(function(container) {
        container.removeAttribute('data-accessories-initialized');
      });
      
      // Re-inicializar
      setTimeout(function() {
        initTabs();
        initSpecsSearch();
        initAccessoriesNavigation();
        initMobileAccordions();
        
        // Restaurar la tab activa que estaba antes del morphing
        if (activeTabTarget) {
          const tabsContainer = document.querySelector('.product-info-tabs');
          if (tabsContainer) {
            const tabToRestore = tabsContainer.querySelector('.js-product-info-tab[data-tab-target="' + activeTabTarget + '"]');
            const panelToRestore = tabsContainer.querySelector(activeTabTarget);
            
            if (tabToRestore && panelToRestore) {
              // Remover is-active de todas las tabs y paneles
              tabsContainer.querySelectorAll('.js-product-info-tab').forEach(function(t) {
                t.classList.remove('is-active');
              });
              tabsContainer.querySelectorAll('.js-product-info-tab-panel').forEach(function(p) {
                p.classList.remove('is-active');
              });
              
              // Activar la tab y panel que estaban activos antes del morphing
              tabToRestore.classList.add('is-active');
              panelToRestore.classList.add('is-active');
              
              // En desktop: mantener accordions sincronizados
              if (window.innerWidth > 749) {
                const accordionItems = tabsContainer.querySelectorAll('.product-info-tabs__accordion-item--desktop');
                accordionItems.forEach(function(item) {
                  const itemPanel = item.querySelector('.js-product-info-tab-panel');
                  if (itemPanel === panelToRestore) {
                    item.open = true;
                  } else {
                    item.open = false;
                  }
                });
              }
              
              // Solo renderizar overview si realmente está activa después de restaurar
              if (isOverviewActiveBeforeMorph && activeTabTarget.includes('product-overview-panel')) {
                setTimeout(function() {
                  window.dispatchEvent(new CustomEvent('overview-panel-shown'));
                }, 150);
              }
            }
          }
        } else {
          // Si no había tab activa antes, verificar si hay una activa ahora (por defecto)
          const activeTabAfterMorph = document.querySelector('.product-info-tabs .js-product-info-tab.is-active');
          if (activeTabAfterMorph) {
            const targetId = activeTabAfterMorph.getAttribute('data-tab-target');
            if (targetId && targetId.includes('product-overview-panel')) {
              setTimeout(function() {
                window.dispatchEvent(new CustomEvent('overview-panel-shown'));
              }, 150);
            }
          }
        }
      }, 50);
    }

    // Escuchar eventos de cambio de variante y morphing de sección
    let morphingTimeout;
    function handleMorphing() {
      clearTimeout(morphingTimeout);
      // Aumentar el delay para asegurar que el morphing haya terminado completamente
      // Usar un delay más largo para dar tiempo al morphing de Shopify
      morphingTimeout = setTimeout(reinitTabsAfterMorphing, 300);
    }

    // Re-inicializar inmediatamente cuando se detecta cambio de variante
    document.addEventListener('variant:update', function() {
      handleMorphing();
    });
    
    document.addEventListener('variant:selected', function() {
      handleMorphing();
    });
    
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      if (section && section.querySelector && section.querySelector('.product-info-tabs')) {
        handleMorphing();
        // También disparar evento para overview si está activa
        setTimeout(function() {
          const activeTab = document.querySelector('.product-info-tabs .js-product-info-tab.is-active');
          if (activeTab && activeTab.getAttribute('data-tab-target') && activeTab.getAttribute('data-tab-target').includes('product-overview-panel')) {
            window.dispatchEvent(new CustomEvent('overview-panel-shown'));
          }
        }, 400);
      }
    });

    // También escuchar cambios en el DOM que puedan indicar morphing
    const morphingObserver = new MutationObserver(function(mutations) {
      // Verificar si hay cambios en los tabs que indiquen morphing
      const hasTabChanges = mutations.some(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          return Array.from(mutation.addedNodes).some(function(node) {
            return node.nodeType === 1 && (
              node.classList && node.classList.contains('product-info-tabs') ||
              node.querySelector && node.querySelector('.product-info-tabs')
            );
          });
        }
        return false;
      });
      
      if (hasTabChanges) {
        handleMorphing();
        // También disparar evento para overview si está activa después del morphing
        setTimeout(function() {
          const activeTab = document.querySelector('.product-info-tabs .js-product-info-tab.is-active');
          if (activeTab && activeTab.getAttribute('data-tab-target') && activeTab.getAttribute('data-tab-target').includes('product-overview-panel')) {
            window.dispatchEvent(new CustomEvent('overview-panel-shown'));
          }
        }, 500);
      }
    });

    // Observar el contenedor principal de la página para detectar morphing
    const mainContent = document.querySelector('main') || document.body;
    if (mainContent) {
      morphingObserver.observe(mainContent, {
        childList: true,
        subtree: true
      });
    }

    // Para mobile: disparar evento cuando se abre un accordion de overview
    function initMobileAccordions() {
      if (window.innerWidth <= 749) {
        document.querySelectorAll('.product-info-tabs__accordion-item--desktop').forEach(function(accordionItem) {
          const details = accordionItem;
          const panel = accordionItem.querySelector('.js-product-info-tab-panel');
          
          if (details && panel && panel.id && panel.id.includes('product-overview-panel')) {
            // Verificar si ya tiene el listener para evitar duplicados
            if (!details.hasAttribute('data-overview-listener')) {
              details.setAttribute('data-overview-listener', 'true');
              
              details.addEventListener('toggle', function() {
                if (details.open) {
                  panel.classList.add('is-active');
                  setTimeout(function() {
                    window.dispatchEvent(new CustomEvent('overview-panel-shown'));
                  }, 100);
                } else {
                  panel.classList.remove('is-active');
                }
              });
            }
          }
        });
      }
    }

    // Inicializar accordions mobile al cargar
    initMobileAccordions();

    // Re-inicializar si cambia el tamaño de la ventana
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth > 749) {
          initTabs();
          // En desktop, abrir todos los accordions y controlar visibilidad con tabs
          document.querySelectorAll('.product-info-tabs__accordion-item--desktop').forEach(function(item) {
            item.open = true;
          });
        } else {
          initMobileAccordions();
        }
      }, 250);
    });

    // En desktop, inicializar todos los accordions abiertos
    if (window.innerWidth > 749) {
      document.querySelectorAll('.product-info-tabs__accordion-item--desktop').forEach(function(item) {
        item.open = true;
      });
    }

    // Navegación de categorías de accesorios - Desktop
    function initAccessoriesNavigation() {
      document.querySelectorAll('[data-accessories-container]').forEach(function(container) {
        // Evitar re-inicialización duplicada
        if (container.hasAttribute('data-accessories-initialized')) {
          return;
        }
        container.setAttribute('data-accessories-initialized', 'true');
        
        // Prevenir que los clicks en el summary activen links dentro del contenido
        const categorySummaries = container.querySelectorAll('.product-accessories__category-summary');
        categorySummaries.forEach(function(summary) {
          summary.addEventListener('click', function(e) {
            // Si el click fue en el summary o en sus elementos hijos directos (título, iconos)
            const clickedElement = e.target;
            const isClickOnSummaryContent = clickedElement === summary || 
                                             clickedElement.closest('.product-accessories__category-title') ||
                                             clickedElement.closest('.svg-wrapper') ||
                                             clickedElement.classList.contains('product-accessories__category-title') ||
                                             clickedElement.classList.contains('svg-wrapper');
            
            if (isClickOnSummaryContent) {
              // Detener la propagación para evitar que active links dentro del contenido
              e.stopPropagation();
              // El comportamiento nativo del details se encargará del toggle
            }
          }, true); // Usar capture phase para interceptar antes de que llegue a otros listeners
        });
      });
    }

    // Inicializar navegación de accesorios
    initAccessoriesNavigation();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-responsive"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  const FLAG = 'slideshowResponsiveARInitialized';
  if (window[FLAG]) return;
  window[FLAG] = true;

  const MIN_WIDTH = 1450;
  const VH_CAP_DEFAULT = 55;
  const VH_CAP_MAX = 80;  

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function updateForSection(sectionEl) {
    if (!sectionEl) return;

    const slideshow = sectionEl.querySelector('slideshow-component');
    if (!slideshow) return;
    if (window.innerWidth < MIN_WIDTH) {
      slideshow.style.removeProperty('--banner-ar');
      slideshow.style.removeProperty('--banner-vh-cap');
      slideshow.style.removeProperty('--banner-h-px');
      return;
    }

    const activeSlide =
      slideshow.querySelector('slideshow-slide:not([aria-hidden="true"])') ||
      slideshow.querySelector('slideshow-slide');

    if (!activeSlide) return;

    const img = activeSlide.querySelector('img') || slideshow.querySelector('img');
    if (!img) return;

    const apply = () => {
      const w = img.naturalWidth || img.width;
      const h = img.naturalHeight || img.height;
      if (!w || !h) return;

      const ar = w / h;
      slideshow.style.setProperty('--banner-ar', ar.toFixed(4));

      const extra = (window.innerWidth - MIN_WIDTH) / 40;
      const vhCap = clamp(VH_CAP_DEFAULT + extra, VH_CAP_DEFAULT, VH_CAP_MAX);
      slideshow.style.setProperty('--banner-vh-cap', `${vhCap}vh`);
      const rect = slideshow.getBoundingClientRect();
      const containerW = rect.width;

      if (!containerW) return;

      const hFromAR = containerW / ar;
      const capPx = (window.innerHeight * vhCap) / 100;
      const bannerH = Math.min(hFromAR, capPx);

      slideshow.style.setProperty('--banner-h-px', `${Math.ceil(bannerH)}px`);
    };

    if (img.complete) apply();
    else img.addEventListener('load', apply, { once: true });
  }

  function updateAll() {
    document
      .querySelectorAll('.slideshow-responsive-section[data-slideshow-responsive]')
      .forEach(updateForSection);
  }

  let t = null;
  function schedule() {
    window.clearTimeout(t);
    t = window.setTimeout(updateAll, 120);
  }

  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('DOMContentLoaded', updateAll);

  document.addEventListener(
    'change',
    (e) => {
      const sec =
        e.target &&
        e.target.closest &&
        e.target.closest('.slideshow-responsive-section[data-slideshow-responsive]');
      if (sec) updateForSection(sec);
    },
    true
  );

  updateAll();
})();

  } catch(e) { console.error(e); }
})();
})();
